/*=============================
=         Form Process        =
=============================*/

var formMessage = document.getElementById('form-message');
var params = new Proxy(new URLSearchParams(window.location.search), {
    get: (searchParams, prop) => searchParams.get(prop),
});

[].slice.call(document.querySelectorAll('.ajax-form')).forEach(function(form) {
    form.addEventListener('submit', formProcess);
    if(params.appointment_type && params.appointment_type == 'Turkish' || params.appointment_type == 'Spanish') {
        document.getElementsByName('appointment_type').forEach(input => {
            if(input.value == 'Virtual') {
                input.checked = true;
            }
        });
    }
});

function formProcess(e) {
    if('performance' in window === false)
        return true;

    e.preventDefault();

    var form = this,
        data = new FormData(form),
        button = this.querySelector('button[type="submit"]');

    button.classList.add('disabled');

    data.append('c_time', performance.now() >= 7000 ? 0 : 1);

    let res

    axios.post('/token')
        .then(function (response) {
            res = response.data
            axios.post(form.action, data, {
                headers: {
                    "X-CSRF-TOKEN": res.token
                }
            })
                .then(function(r) {
                    Velocity(form, 'slideUp', {duration: 500, delay: 500});
                    clearErrors(form);
                    formMessage.classList.add('success');
                    formMessage.innerHTML = r.data.message;

                    // if(r.data.email)
                    //  runSF('email', r.data.email);

                    if(typeof dataLayer !== 'undefined')
                        dataLayer.push({'event': 'FormSubmission'});
                })
                .catch(function (e) {
                    setTimeout(function() {
                        button.classList.remove('disabled');
                    }, 500);

                    // console.log(e.response.data.errors);

                    formMessage.classList.add('error');
                    formMessage.innerHTML = e.response.data.message;

                    if(e.response.status===422) {
                        clearErrors(form);
                        setErrors(form, e.response.data.errors);
                    }
                });
        })
        .then(function (t) {
            if (!res.auth) {
                axios.delete('/token')
            }
        });
}

function clearErrors(form) {
    var errors = form.getElementsByClassName('error');

    for(var e=errors.length - 1; e>=0; e--)
        errors[e].classList.remove('error');

    Velocity(formMessage, 'scroll', {
        duration: 500,
        offset: -header.offsetHeight
    });
}

function setErrors(form, errors) {
    var firstField = false;

    if(Object.keys(errors).length) {
        var errorsList = document.createElement('ul');

        formMessage.appendChild(errorsList);
    }

    for(var key in errors) {
        var label = form.querySelector('label[for="'+key+'"]');

        if(label)
            label.parentNode.classList.add('error');

        if(key == 'g-recaptcha-response')
            document.querySelector('.g-recaptcha').classList.add('error');

        var field = form.querySelector('*[name="'+key+'"]');

        field.setAttribute('aria-describedby', key+'_error');

        if(!firstField) {
            field.focus();
            firstField = true;
        }

        var li = document.createElement('li');

        li.setAttribute('id', key+'_error');
        li.innerHTML = errors[key];
        errorsList.appendChild(li);
    }
}

/*=============================
=      Conditional Display    =
=============================*/

// [].slice.call(document.querySelectorAll('#referral')).forEach(function(field) {
//  field.addEventListener('change', function() {
//      var otherField = main.querySelector('label[for="'+this.getAttribute('other_field')+'"]').parentNode,
//          parent = this.parentNode.parentNode;

//      if(!this.value.indexOf('Physician - ')) {
//          parent.classList.add('half');
//          otherField.classList.remove('hidden');
//      }
//      else {
//          if(!parent.classList.contains('keep-half'))
//              parent.classList.remove('half');

//          otherField.classList.add('hidden');
//      }
//  });
// });


